import factor from 'renative/src/Api/factor';

export default factor;
